export default __webpack_public_path__ + "static/media/sluch-rytmizace.e4fece90.svg";